type DateString = string

export const fromJSDate = (jsDate: Date): DateString => jsDate.toISOString().split('T')[0]
